import React, { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { BellRing } from "lucide-react";
import { enablePush } from "@/lib/push";
import { toast } from "sonner";

export default function PushPrompt() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (typeof window === "undefined" || !("Notification" in window)) return;
    const dismissed = localStorage.getItem("cr_push_prompt");
    if (!dismissed && Notification.permission === "default") {
      const t = setTimeout(() => setOpen(true), 2500);
      return () => clearTimeout(t);
    }
  }, []);
  const dismiss = () => { localStorage.setItem("cr_push_prompt", "1"); setOpen(false); };
  const yes = async () => {
    localStorage.setItem("cr_push_prompt", "1");
    try {
      const ok = await enablePush();
      toast[ok ? "success" : "info"](ok ? "Notifications enabled!" : "You can enable them later from your browser.");
    } catch (e) { toast.error(e.message || "Could not enable notifications"); }
    setOpen(false);
  };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) dismiss(); }}>
      <DialogContent data-testid="push-prompt">
        <DialogHeader>
          <div className="w-12 h-12 rounded-2xl bg-teal/10 text-teal flex items-center justify-center mb-2"><BellRing className="w-6 h-6" /></div>
          <DialogTitle>Stay in the loop</DialogTitle>
          <DialogDescription>Want to get updates from Coach Reyland even when you are away from the website? Click Yes to allow notifications and you'll get an alert on your device.</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" className="rounded-full" onClick={dismiss} data-testid="push-no">Not now</Button>
          <Button className="rounded-full bg-teal hover:bg-teal/90" onClick={yes} data-testid="push-yes">Yes, notify me</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
